import React, { ReactElement, FC, ReactNode } from 'react'
import { Typography } from 'antd'

const { Text } = Typography

interface StepTitleProps {
  title: string
  subtitle?: string
  extra?: ReactNode
}

const TITLE_CONTAINER: React.CSSProperties = {
  paddingLeft: '12px',
  display: 'flex',
  flexDirection: 'column',
  lineHeight: '24px',
  marginBottom: '2px'
}

const SUBTITLE_TEXT: React.CSSProperties = {
  fontSize: '14px'
}

export const StepTitle: FC<StepTitleProps> = ({ title, subtitle, extra }): ReactElement => {
  if (extra) {
    return (
      <div style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
      }}>
        <div style={TITLE_CONTAINER}>
          <Text strong>{title}</Text>
          {subtitle && <Text style={SUBTITLE_TEXT}>{subtitle}</Text>}
        </div>
        {extra}
      </div>
    )
  } else {
    return (
      <div style={TITLE_CONTAINER}>
        <Text strong>{title}</Text>
        {subtitle && <Text style={SUBTITLE_TEXT}>{subtitle}</Text>}
      </div>
    )
  }
}
